const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "2024年核聚变电子游戏嘉年华招商开启"
const desc =
  "「核聚变」是由机核网主办、承办的线下大型电子游戏嘉年华活动。「核聚变」也是目前国内最垂直，覆盖城市最多的游戏玩家盛会，到场观众以18-39岁的青年群体为主，参展商涉及游戏制作、游戏发行、3C数码品牌、电子竞技赛事、模玩桌游、文化服饰、图书出版、新消费快消品等诸多领域。"

const cdnUrl = "https://gfusion.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
}
